var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 256,
    cx: 256,
    cy: 256,
    fill: "#38E7AD",
    shape: "circle",
    transform: "matrix(1,0,0,1,0,0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.7,0,0,0.7,76.79999985694886,76.80000343322754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.456 94.854c-22.644-.243-41.573 18.108-41.998 40.749a41.347 41.347 0 0 0 8.437 25.898c4.976 6.547 13.555 9.167 21.404 6.712 3.733-1.167 7.95-1.825 12.415-1.825 4.084 0 7.96.55 11.449 1.537 7.997 2.263 16.592-.416 21.477-7.14a41.343 41.343 0 0 0 7.91-24.385c0-22.794-18.357-41.302-41.094-41.546z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: "13px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.593,
    cy: 84.48,
    rx: 12.553,
    ry: 15.876,
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    transform: "rotate(-45.001 195.593 84.482)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: "13px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 232.177,
    cy: 58.383,
    rx: 12.553,
    ry: 15.876,
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    transform: "rotate(-17.362 232.16 58.383)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: "13px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 316.407,
    cy: 84.48,
    rx: 15.876,
    ry: 12.553,
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    transform: "rotate(-45.001 316.407 84.484)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: "13px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 279.823,
    cy: 58.383,
    rx: 15.876,
    ry: 12.553,
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    transform: "rotate(-72.638 279.841 58.382)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: "13px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.745 128.978h23.78M146.745 157.198h40.074M365.254 128.978h-23.779M365.254 157.198h-40.073M29.914 235.742h452.171v262.876H29.914zM436.709 411.345h45.377M163.938 411.345h65.128M29.914 411.345h36.987M497.824 198.509H14.176a6.676 6.676 0 0 0-6.676 6.676v23.88a6.676 6.676 0 0 0 6.676 6.676h483.648a6.676 6.676 0 0 0 6.676-6.676v-23.88a6.676 6.676 0 0 0-6.676-6.676zM7.5 498.618h497M333.543 289.563v157.36M133.378 435.866v7.094",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: "13px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.332 281.868h-9.248a4.294 4.294 0 0 1-4.294-4.294v-9.248a4.294 4.294 0 0 0-4.294-4.294h-20.477a4.294 4.294 0 0 0-4.294 4.294v9.248a4.294 4.294 0 0 1-4.294 4.294h-9.248a4.294 4.294 0 0 0-4.294 4.294v20.477a4.294 4.294 0 0 0 4.294 4.294h9.248a4.294 4.294 0 0 1 4.294 4.294v9.248a4.294 4.294 0 0 0 4.294 4.294h20.477a4.294 4.294 0 0 0 4.294-4.294v-9.248a4.294 4.294 0 0 1 4.294-4.294h9.248a4.294 4.294 0 0 0 4.294-4.294v-20.477a4.293 4.293 0 0 0-4.294-4.294zM69.58 472.238v26.31h93.358V362.945a4.97 4.97 0 0 0-4.969-4.969h-83.42a4.97 4.97 0 0 0-4.969 4.969v80.293M370.232 289.563H237.398a6.02 6.02 0 0 0-6.02 6.02v145.321a6.02 6.02 0 0 0 6.02 6.02h192.291a6.02 6.02 0 0 0 6.02-6.02V295.583a6.02 6.02 0 0 0-6.02-6.02h-30.458M162.589 13.382h-26.383c-10.45 0-18.922 8.472-18.922 18.922V198.51h277.431V32.304c0-10.45-8.471-18.922-18.922-18.922H191.589",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: "13px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationCircle);
export default __webpack_public_path__ + "static/media/location-circle.23dbffc167e286a6ce87cd3f52bb515f.svg";
export { ForwardRef as ReactComponent };